<div class="breadcrumb-list">
    <div class="d-flex" *ngFor="let item of itemsBreadCrumb; let i = index" (click)="goPage(item.url, item.params)">
        <p class="m-0 name-breadcrumb">{{item.name}}</p>
        <mat-divider [vertical]="true" *ngIf="i != (itemsBreadCrumb.length-1)"></mat-divider>
    </div>
</div>